import { render } from "./ProductSellComponent.vue?vue&type=template&id=25284bf8"
import script from "./ProductSellComponent.vue?vue&type=script&lang=js"
export * from "./ProductSellComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__